<template>
    <modal :show="show" @close="close()">

        <div class="p-3">

            <h2 class="text-center mb-4">Choose your plan</h2>

            <div class="h-100 overflow-y-auto">
                <component 
                    v-for="bill in this.sortedBills"
                    :key="bill.id"
                    :is="cardType(bill.bill.group)"
                    :bill="bill.bill"
                    :bills="sortedBills"
                    :packageBill="bill"
                    :housemates="housemates"
                    :selected="false"
                    :hide-prices="true"
                    @toggle="switchBill($event)">
                </component>
            </div>

        </div>

    </modal>
</template>

<script>
    import Modal from "../../Modal";
    import BillCardInternet from "../../onboarding/bill/BillCardInternet";
    import BillCardTvPackage from "../../onboarding/bill/BillCardTvPackage";
    import BillCardEnergy from "../../onboarding/bill/BillCardEnergy";

    export default {
        name: "PartnerBillCompareModal",

        components: { Modal, BillCardInternet, BillCardTvPackage, BillCardEnergy },

        props: {
            show : {
                type: Boolean,
                default: false
            },
            bills: {
                type: Array,
                default: []
            },
            housemates : {
                type: Number,
                required: true
            }
        },

        methods: {
            close() {
                this.$emit('close');
            },

            switchBill(bill_id) {
                this.$emit('switch', bill_id);
            },

            cardType(group) {
                switch (group.name) {
                    case 'Renewable Energy':
                        return 'BillCardEnergy';
                    case 'Internet':
                        return 'BillCardInternet';
                    case 'TV Package':
                        return 'BillCardTvPackage'
                }
            }
        },

        computed: {

            sortedBills() {
                return _.orderBy(this.bills, 'bill.provider.name', 'asc');
            },

        }
    }
</script>

<style scoped>

</style>
